// ----------------------------------------------------------------------

const en = {

  chatService: {
    french: "french",
    english: "english",
    spanish: "spanish",
    german: "german"
  },

  home: {
    welcome: "Welcome to your Click-To-Connect Administration Center",
    unify: "Unify Customer Communications Across Web and WhatsApp",
    empower: "Empower your agents to connect with customers instantly—whether they reach out via your Website or WhatsApp.",
    support: "Seamless Multichannel Support:",
    rainbow: "With Rainbow Click-To-Connect, every Web or WhatsApp inquiry is routed to your Rainbow Agent team, ensuring no message is missed and every customer feels heard.",
    website: "Active Website Channel:",
    communication: "Transform your website into a dynamic, two-way Chat, Audio or Video communication hub.",
    whatsapp: "WhatsApp Channel:",
    business: "Increase your customer reach by enabling your WhatsApp Business communication channel.",
    resources: "C2C Administration resources: "
  },
  dashboard: {
    welcome: "Welcome back to the Click-To-Connect Administration Center",
    construction: "Dashboard under construction"
  },
  skills: {
    global: {
      title: "Routing Rules General Settings",
      maxNbrOfChats: "Max number of chats",
      adminGroupName: "Admin group name",
      bubbleTTL: "Bubble TTL in seconds",
      alertMessage: "Alert message",
      discardPresence: "Disregard presence",
      availableOnMobile: "Available on mobile (presence state)",
      pop1: "Maximum number of chats an agent can manage. He is considered as busy if he reaches this level",
      pop2: "Name of admin group in bot contacts list. Member of this group receives ticket report every day",
      pop3: "Every night, old bubbles are deleted. Old bubbles means bubbles older than this level in seconds. 172800 seconds equals 2 days",
      pop4: "Set the welcome message as Important. Agent is notified with an alert sound",
      pop5: "Do not take into account presence in agent selection. Agent is selected even if he is on phone, away ,in a meeting, with max number of chats... but not offline",
      pop6: "Consider agent's mobile presence as available"
    },
    skills: {
      title: "Domains and Subjects management",
      addSkillBtn: "+ Add a new Domain",
      formAddSkillBtn: "Add to the list",
      formAddSkillTitle: "Create a new Domain",
      formSkillName: "Domain name",
      formDescription: "Description",
      addGroupBtn: "Add a new Subject",
      formGroupBtn: "Add to the list",
      formGroupTitle: "Create a new Subject",
      formGroupName: "Subject name",
      formGroupNameExist: "Ex: solutions",
      formGroupFormValueEnglish: "English value in form",
      formGroupFormValueFrench: "French value in form",
      formGroupFormValueSpanish: "Spanish value in form",
      formGroupFormValueGerman: "German value in form",
      formGroupFormValueChinese: "Chinese value in form",
      formGroupFormValueExist: "Value",
      formGroupTelNumber: "Telephony number",
      formGroupTelExist: "Only digit",
      formGroupBot: "Bot Subject",
      cancelBtn: "- Cancel",
      cancelBtn2: "Cancel",
      pop1: "For a subject to be taken into account via the connection URL, its name must not contain any capital letters or special characters; 20 characters max"
    },
    groups: {
      domain: "Domain",
      subject: "Subject",
      toolbarBackBtn: "Back to Domains & Subjects",
      formGroupBtn: "Edit Subject",
      formGroupBtn2: "Update the Subject",
      formGroupBtn3: "Save",
      formGroupName: "Subject Name",
      formGroupNameExist: "Ex: solutions",
      formGroupFormValueEnglish: "English value in form",
      formGroupFormValueFrench: "French value in form",
      formGroupFormValueSpanish: "Spanish value in form",
      formGroupFormValueGerman: "German value in form",
      formGroupFormValueChinese: "Chinese value in form",
      formGroupFormValueExist: "Value",
      formGroupTelNumber: "Telephony number",
      formGroupTelExist: "Only digit",
      formGroupBot: "Bot Subject",
      sideInfosType: "Subject type",
      sideInfosCreationDate: "Creation date",
      sideInfosEditionDate: "Edition date",
      cancelBtn2: "Cancel",
      sideAgentsTitle: "Agents",
      sideAgentsNoAgent: "There are no agents on this Subject yet",
      addAgentsBtn: "Assign agents",
      formAgentsBtn: "Add to the list",
      formAgentsName: "Assign Agents to the Subject"
    },
    agents: {
      title: "Agents management",
      inviteAgentBtn: "+ Invite an agent",
      cancelBtn: "- Cancel",
      formMessage: "To invite a new agent, please enter his email address bellow",
      sendBtn: "Send"
    }
  },
  interface: {
    global: {
      title: "Overall UI management",
      primaryColor: "Primary color",
      languages: "Languages",
      english: "English",
      french: "French",
      german: "German",
      spanish: "Spanish",
      chinese: "Chinese",
      defaultLanguage: "Default language",
      redirectUrl: "Redirect URL",
      guestLeftMessage: "Guest left message",
      otherOptions: "Others options",
      pop1: "List of languages ​​taken into account",
      pop2: "Default language used if the language captured by the frontend is not taken into account in the list above",
      pop3: "Address of the page to go to in case of no agents available",
      pop4: "Message sent to the agent when the guest leaves the conference",
      pop5: "Enables automatic answer. No popup is displayed. Guest is automatically in the conference",
      pop6: "Starts the call with audio and video"
    },
    form: {
      title: "Web Form Configuration",
      imageMsg: "Drop your image here or clic to select an image (only .png, .jpg and .jpeg)",
      titleColor: "Form introduction text",
      buttonColor: "Form button text",
      messageColor: "Color of the form introduction text",
      field: 'Field',
      fieldsTitle: "Fields",
      fieldsValueEnglish: "English: ",
      fieldsValueFrench: "French: ",
      fieldsValueSpanish: "Allemand: ",
      fieldsValueGerman: "Spanish: ",
      fieldsValueChinese: "Chinese: ",
      addFieldBtn: "Add a new field",
      addItemBtn: "Add an item",
      addFieldName: "ID of the field",
      addFieldId: 'List ID',
      addItemId: 'Item ID',
      addFieldExist: "Ex: firstname",
      addFieldValueEnglish: "English value in form",
      addFieldValueFrench: "French value in form",
      addFieldValueSpanish: "Spanish value in form",
      addFieldValueGerman: "German value in form",
      addFieldValueChinese: "Chinese value in form",
      addFieldValueExist: "Value",
      addBtn: "Add to the list",
      typeBtn: "FIELD TYPE",
      sizeBtn: "TYPE",
      UpdateBtn: "Update the field",
      deletetn: "Delete",
      cancelBtn: "Cancel",
      cropCancelBtn: "Cancel",
      cropValidateBtn: 'Crop',
      liveMessage1: "Please answer the following questions",
      liveMessage2: "- I accept and send my request -",
      pop1: "Message color"
    },
    chat: {
      title: "Web Chat & Video Configuration",
      imageMsg: "Drop your image here or clic to select an image (only .png, .jpg and .jpeg)",
      customMessages: "Custom messages",
      otherOptions: "Other options",
      formTitleMessage: "Title message",
      formBtnMessage: "Button message",
      welcomeMessageTitle: "Welcome message",
      endMessageTitle: "End of conversation message",
      guestLeftMessageTitle: "Agent message when the guest has left the conversation",
      topBarColorTitle: "Top Bar",
      agentMessageBGC: "Agent BG",
      userMessageBGC: "User BG",
      agentMessageTxtColor: "Agent Text",
      userMessageTextColor: "User Text",
      hyperlinkMessagesTextColor: "Hyperlink",
      userMessage: "Hello",
      english: "English",
      french: "French",
      german: "German",
      spanish: "Spanish",
      chinese: "Chinese",
      pop1: "Top bar color",
      pop2: "Background color of agent messages in chat",
      pop3: "Background color of user messages in chat",
      pop4: "Text color of user messages in chat",
      pop5: "Text color of agent messages in chat",
      pop6: "Text color of hyperlink in chat",
      pop7: "Use the rear camera by default for mobiles or tablets",
      pop8: "Show the icon to switch between im and video views",
      pop9: "Use the screen sharing on desktop"
    }
  },
  settingsV2: {
    whatsapp: {
      loading: "Loading...",
      metaApp: "Meta Application",
      appID: "APP ID : ",
      reconnectBtn: "Reconnect",
      reconnectPop: "Your Click-To-Connect WhatsApp Meta session has expired, please reinitiate your session by reconnecting to your meta account.",
      disconnectBtn: "Reset",
      disconnectPop: "Reset your WhatsApp Business Account Settings",
      disconnectMessage: "You are about to reset your WhatsApp Business Account Settings, do you confirm ?",
      yesBtn: "Yes",
      noBtn: "No",
      rainbowConversations: "Rainbow Conversations",
      cleanBtn: "Clean",
      limitHeader: "20 characters maximum",
      limitBody: "1024 characters maximum",
      limitButton: "20 characters maximum",
      waSettings: "Whatsapp Settings",
      formCredentials: "Form authentication",
      userId: "App ID",
      password: "App secret key",
      tempToken: "Temporary access token",
      register: "Register",
      messCustom: "Custom messages",
      welcomeTitle: "Welcome title",
      skillsGroupsBody: "Domain selection message",
      skillsGroupsTitle: "Domain picklist label",
      agentsGroupsBody: "Subject selection message",
      agentsGroupsTitle: "Subject picklist label",
      reasonsButton: "Select button label",
      connectingAgent: "Connecting with an agent",
      connectedAgent: "Connected with an agent",
      convTerminated: "Conversation ended",
      noAgentMessage: "'No agents available' message"
    },
    telephony: {
      title: "Telephony Settings",
      pbxID: "PBX ID",
      ranges: "Ranges",
      defaultNumber: "Default Number",
      pop1: "PBX ID",
      pop2: "Ranges of available REX numbers. Format is startRange1:endRange1,startRange2:endRange2. Example: 3300:3400,3500:3550",
      pop3: "Default number used (/?telephony=true)"
    },
    sms: {
      title: "SMS Settings",
      roomName: "Room name",
      smsText: "Invitation message",
      pop1: "text + client phone number",
      pop2: "text + link",
      noConfig: "You need the RVA Expert Licence for this feature..."
    },
    routing: {
      title: "External routing",
      noRoutes: "No routes have been recorded yet",
      addRouteBtn: "Add a new route",
      routeNameExist: "Route name",
      routePathExist: "Route path",
      addToTheListBtn: "Add to the list",
      cancelBtn: "Cancel"
    },
    tasks: {
      title: "Tasks settings",
      agentsAndBubblesSync: "Agents and bubbles synchronization",
      cleanOldBubbles: "Clean old bubbles",
      scrapping: "Scrapping (poll agents availability)",
      report: "Send daily tickety report"
    }
  },
  menuLeft: {
    dashboard: "Home",
    skills: "Routing rules",
    skillsAndGroups: "Domains & Subjects",
    generalSettings: "General Settings",
    userInterface: "User Interface",
    form: "Form"
  },
  general: {
    saveBtn: "Save Changes",
    settingsTitle: "Settings",
    telephony: "Telephony",
    sms: "SMS",
    routing: "External routing",
    tasks: "Tasks"
  },
  snackbars: {
    getDataError: "Data not recovered",
    sendDataError: "Configuration not saved",
    sendDataSuccess: "Configuration saved"
  },
  regex: {
    digit: "The field should have digits only",
    regSGMsg: "A number cannot start with 0, it must be at least 3 characters long and spaces, capital letters and special characters are prohibited",
    regNumberMsg: "3 numeric characters minimum",
    regSpaceMsg: "Spaces alone or at the beginning of a string are prohibited",
    regUrlMsg: "You must enter a valid URL",
    regCronMsg: "Only 6-value cron expressions are allowed",
    regRangesMsg: "The authorized format is as follows : 1111:1120.",
    regPBXMsg: "The authorized format is as follows : PBXeah3-j2dd-8ab9-4c60-89a1-fc6d-bb91-6x2f."
  },














  login: {
    welcome: 'Hi, welcome back',
    message: 'Rainbow',
    button: 'Login with Rainbow',
    tokenExpired: 'Session expired. You have to log in again.',
    tooltip: 'Login with Rainbow so you can export your records.'
  },
  nav: {
    home: 'Home',
    settings: 'Settings',
    logout: 'Logout',
    dashboard: 'Dashboard',
    analytics : `Dashboard`,
    exporter : `Records`,
    cdr : 'CDR'
  },
  analytics: {
    welcomeMessage : `Welcome back on Rainbow Exporter`,
    widgets: {
      monthlyExport: 'Monthly Export (recordings)',
      weeklyExport: 'Weekly Export (recordings)',
      dailyExport: 'Daily Export (recordings)',
      thanLastMonth: 'than last month',
      thanLastWeek: 'than last week',
      thanLastDay: 'than last day',
      noEvoForMonth: 'no evolution since last month',
      noEvoForWeek: 'no evolution since last week',
      noEvoForDay: 'no evolution since last day',
      exportState: 'States',
      exported: "Exported",
      pending: 'Pending',
      new: 'New',
      failed: 'Failed', 
      exportToStorage: 'Traffic (recordings)',
      exportOn: 'exported on',
      files: 'files',
      exportTimelineRecs: 'Records timeline',
      exportTimelineCDRs: 'CDR timeline',
      recordDateTypo: 'Record : ',
      exportDateTypo: 'Export : ',
      billingPeriod: "Period : ",
      exportMethod: "Method : ",
      exportDest: "Destination : ",
      statusAllType: "All",
      statusRecsType: "Recordings",
      statusCDRsType: "CDR"
    }
  },
  exporter: {
    title: 'Records',
    update: 'Update data',
    updateTooltip: 'Update the records list',
    all: 'All',
    exported: 'Exported',
    pending: 'Pending',
    failed: 'Failed',
    recordDate: 'Date',
    exportDate: 'Exported on',
    startDate: 'Start date',
    endDate: 'End date',
    searchInfo: 'Search user or file name...',
    user: 'User',
    fileName: 'Record',
    size: 'Size',
    state: 'State',
    exporting: 'Exporting...',
    exportDone: 'Export done',
    exportButtonTooltip: 'Export to ',
    selected: 'selected',
    clear: 'clear',
    exportFail: 'One or more records have already been exported',
    dateType: "date type",
    exportedState: "Exported",
    failedState: "Failed",
    pendingState: "Pending",
    newState: "New",
    noChange: 'No change...',
    okChange: "Update done with success",
    exportFailed: "Error when exports records",
    fetchFailed: "Error when fetching records",
    alreadyExported: "One or more Records had already been exported and therefore were not duplicated to this destination : ",
    okExported: "Record(s) successfully exported to this destination : ",
    noExisted: "Error during export : One or more Records do not exist : ",
    driveError: "Error during export : There is an issue with the destination : ",
    lastLabelOn: "Exports destination for your records : ",
    lastLabelOff: "No destination has yet been registered for the export of your records",
    new: 'New',
    noValidIds: 'Some records do not have a valid ID',
    noValidId: 'A record does not have a valid ID',
    noExistIds: 'Some records do not exist',
    noExistId: 'A record does not exist',
    alreadyExportedIds: 'Some records are already exported',
    alreadyExportedId: 'A record is already exported',
    pendingIds: 'Records are being exported',
    pendingId: 'A record is being exported',
    error: "Error during recording's export",
    downloadRecordFailed: "Error during the download of record on local"
  },
  cdr: {
    title: "CDR",
    update: 'Update data',
    updateTooltip: 'Update the CDR list',
    startDate: 'Start date',
    endDate: 'End date',
    creationDate: 'Creation date',
    billingDate: 'Billing date',
    searchInfo: "Search CDR...",
    fileName: 'CDR',
    downloadDone: 'Download done with success',
    downloadButtonTooltip: 'Download on local',
    selected: 'selected',
    clear: 'clear',
    dateType: "Date type",
    noChange: 'No change...',
    okChange: "Update done with success",
    downloadCDRFailed: "Error during the download of CDR on local",
    fetchFailed: "Error when fetching CDR",
    alreadyExported: "One or more CDR had already been exported and therefore were not duplicated to this destination : ",
    okExported: "All CDR were successfully exported to this destination : ",
    noExisted: "Error during export : One or more CDR do not exist : ",
    driveError: "Error during export : There is an issue with the destination : ",
    lastLabelOn: "Exports destination for your CDR : ",
    lastLabelOff: "No destination has yet been registered for the export of your CDR",
    new: 'New',
    noValidIds: 'Some cdrs do not have a valid ID',
    noValidId: 'A cdr does not have a valid ID',
    noExistIds: 'Some cdrs do not exist',
    noExistId: 'A cdr does not exist',
    alreadyExportedIds: 'Some cdrs are already exported',
    alreadyExportedId: 'A cdr is already exported',
    pendingIds: 'Cdrs are being exported',
    pendingId: 'A cdr is being exported',
    error: "Error during cdr's export"
  },
  settings: {
    title: 'Settings',
    updateSucces: 'Updated successfully',
    updateFail: 'Update failed',
    googleDriveId: "Google Drive ID",
    googleDriveHelp: "Please share the id of the Google Dive's folder to export on",
    googleDriveCurrent: 'Current Google Drive id :',
    idAlreadyExist: "This ID already exists",
    saveBtn: 'Save Changes',
    emailLink: "Email",
    emailType: "Email type",
    emailAlreadyExist: "This email already exists in the list",
    frequenceTitle: "Notification frequency",
    frequency: "Frequency",
    actualFrequency: "Actual frequency :",
    emailsList: "Emails List",
    noEmail: "No Email has been entered yet",
    addEmail: "Add an Email to the list",
    badEmail: "Invalid Email",
    required: 'Required',
    deleteBtn: "Delete",
    AbortBtn: "Cancel",
    addEmailBtn: "Add Email",
    never: "never",
    daily: "daily",
    weekly: "weekly",
    monthly: "monthly",
    enable: "Enable",
    disable: "Disable",
    required: 'Required',
    configAlreadyExist: "This configuration already exist",
    recsDestination: "Recordings destination",
    cdrDestination: "CDR destination",
    exportActivation : "Exports automation",
    driveSelection : "Destination selection",
    actualState: "Current state :",
    actualDrive: "Current destination :",
    active: "Enabled",
    inactive: "Disabled",
    noDestination: "No destination has been saved yet",
    driveAlreadyExist: "This drive already exist",
    sftpList: "SFTP drives list",
    noDriveSFTP: "No SFTP drive has been saved yet",
    addDrive: "Add a drive to the list",
    labelName: "Name",
    helperName: "A name for your Drive",
    labelUrl: "SFTP domain/IP",
    helperUrl: "Your exports destination domain or IP",
    labelPath: "SFTP path",
    helperPath: "Your destination folder (ex: pathName)",
    labelLogin: "SFTP user",
    helperLogin: "The user to connect to the SFTP url",
    labelPass: "SFTP password",
    helperPass: "The password to connect to the SFTP url",
    addDrivePlus: "Add a drive",
    cancel: "Cancel",
    noDriveGoogle: "No Google drive has been saved yet",
    googleList: "Google drives list",
    googleId: "Folder ID",
    autoLabel: "Destinations & Automation",
    lastSyncWithRainbow: "Last sync with Rainbow:",
    mini2Dest: "You must enter at least 2 destinations",
    noFieldSelected: "No field have been selected",
    drivesList: "List of drives",
    noDrivesOnSettings: "No drive is registered",
    driveTypeSelection: "Select a drive type"
  },
  page404: {
    home: "Home",
    contact: 'Contact us',
    login: 'Login',
    notFoundSorry: "Sorry, page not found !",
    notFoundMessage: "We couldn’t find the page you’re looking for.",
    networkIssue: "There is a network issue, please contact us.",
    urlMistyped: "Perhaps you’ve mistyped the URL? Be sure to check your spelling."
  },
  page401: {
    home: "Home",
    contact: 'Contact us',
    login: 'Login',
    inaccessibleSorry: "Sorry, inaccessible page !",
    unauthorizedMessage: "You are not authorized to view this application.",
    requestIssue: "The request failed with on code 401."
  },
  noServer: {
    home: "Home",
    contact: 'Contact us',
    login: 'Login',
    inaccessibleSorry: "Sorry, inaccessible page !",
    noServerMessage: "The server is not responding.",
    requestIssue: "The request was sent but no response was received.",
    reconnect: "The server is offline, we try to reconnect",
    logout: "Failed to reconnect to server, please retry later",
    offline: "The server is offline, please retry later",
    badApi: "The API adress is not valid"
  },
  error: {
    responseType: "The request was sent but the server response contains an error code.",
    requestType: "The request was sent but no response was received from the server.",
    otherType: "There was an error constructing the request."
  },
  noData: {
    records: "There is no recording",
    cdr: "There is no CDR"
  }
};

export default en;
